import { UpdateProjectAlertEmails } from '@/connection/emails/project-alert-emails';
import { serializeError } from '@/store/utils/serialize-error';
import { ChannelSettingsReducerCreator } from '../types';

const updateProjectAlertEmailsReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(
    async ({ channel, emails }: { channel: number; emails: string[] }, { rejectWithValue }) => {
      try {
        const results = await UpdateProjectAlertEmails({ channel, emails });

        return results;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        state.projectAlertEmails = action.payload;
      },
    }
  );
};

export default updateProjectAlertEmailsReducer;
